export default __webpack_public_path__ + "static/zt-award-group-2-867e32a0cbfd98e24cd1c222f7982748.png";